import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
// 当设置 true 的时候该路由不会在侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
hidden: true // (默认 false)
//当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
redirect: 'noRedirect'
// 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
// 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
// 若你想不管路由下面的 children 声明的个数都显示你的根路由
// 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
alwaysShow: true
name: 'router-name' // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
这里的路由分为两种，constantRoutes 和 asyncRoutes。
constantRoutes： 代表那些不需要动态判断权限的路由，如登录页、404、等通用页面。
asyncRoutes： 代表那些需求动态判断权限并通过 addRoutes 动态添加的页面。
 **/

export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/agreement', component: () => import('@/views/agreement/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/bus',
    component: Layout,
    redirect: '/bus/admin',
    name: 'bus',
    meta: {title: '权限设置', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/bus/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/bus/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/bus/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/bus/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'bus-menu',
        name: 'bus-menu',
        component: () => import('@/views/bus/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'bus-addMenu',
        name: 'bus-addMenu',
        component: () => import('@/views/bus/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'bus-updateMenu',
        name: 'bus-updateMenu',
        component: () => import('@/views/bus/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'bus-resource',
        name: 'bus-resource',
        component: () => import('@/views/bus/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'bus-resourceCategory',
        name: 'bus-resourceCategory',
        component: () => import('@/views/bus/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
    ]
  },{
    path:'/stu',
    component: Layout,
    redirect: '/stu/course',
    name: 'stu',
    meta: {title: '拙诚课程', icon: 'ums'},
    children: [
      {
        path: 'courseCategory',
        name: 'courseCategory',
        component: () => import('@/views/stu/courseCategory/index'),
        meta: {title: '课程分类', icon: 'ums-admin'}
      },
      {
        path: 'courseAdd',
        name: 'courseAdd',
        component: () => import('@/views/stu/course/edit'),
        meta: {title: '课程编辑', icon: 'ums-admin'}, 
        hidden: true
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/stu/course/index'),
        meta: {title: '拙诚课程', icon: 'ums-admin'}
      },
      {
        path: 'courseV1',
        name: 'courseV1',
        component: () => import('@/views/stu/course/indexV1'),
        meta: {title: '新拙诚课程', icon: 'ums-admin'}
      },
      {
        path: 'courseItem',
        name: 'courseItem',
        component: () => import('@/views/stu/courseItem/index'),
        meta: {title: '单节课程', icon: 'ums-admin'}
      },
      {
        path: 'courseActivity',
        name: 'courseActivity',
        component: () => import('@/views/stu/courseActivity/index'),
        meta: {title: '精彩活动', icon: 'ums-admin'}
      }
    ]
  },{
    path:'/fro',
    component: Layout,
    redirect: '/fro/member',
    name: 'fro',
    meta: {title: '用户管理', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/fro/member/index'),
        meta: {title: '用户管理', icon: 'ums-admin'}
      },
      {
        path: 'memberQuery',
        name: 'memberQuery',
        component: () => import('@/views/fro/member/indexQuery'),
        meta: {title: '用户管理查', icon: 'ums-admin'}
      },
      {
        path: 'memberLog',
        name: 'memberLog',
        component: () => import('@/views/fro/memberLog/index'),
        meta: {title: '用户修改记录', icon: 'ums-admin'}
      },
      {
        path: 'agentWk',
        name: 'agentWk',
        component: () => import('@/views/fro/agent/index'),
        meta: {title: '微课用户', icon: 'ums-admin'}
      },
      {
        path: 'agentLog',
        name: 'agentLog',
        component: () => import('@/views/fro/agentLog/index'),
        meta: {title: '修改记录', icon: 'ums-admin'}
      },
      {
        path: 'memberLevel',
        name: 'memberLevel',
        component: () => import('@/views/fro/memberLevel/index'),
        meta: {title: '用户层级', icon: 'ums-admin'}
      },
    ]
  },

  {
    path:'/bra',
    component: Layout,
    redirect: '/bra/office',
    name: 'bra',
    meta: {title: '分公司管理', icon: 'ums'},
    children: [
      {
        path: 'office',
        name: 'office',
        component: () => import('@/views/bra/office/index'),
        meta: {title: '分公司管理', icon: 'ums-admin'}
      },
      {
        path: 'officeCapitalLog',
        name: 'officeCapitalLog',
        component: () => import('@/views/bra/officeCapitalLog/index'),
        meta: {title: '分公司资产明细', icon: 'ums-admin'}
      },
      {
        path: 'officeLog',
        name: 'officeLog',
        component: () => import('@/views/bra/officeLog/index'),
        meta: {title: '分公司修改记录', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreMonth',
        name: 'officeScoreMonth',
        component: () => import('@/views/bra/officeScoreMonth/index'),
        meta: {title: '月综合评分', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreWeek',
        name: 'officeScoreWeek',
        component: () => import('@/views/bra/officeScoreWeek/index'),
        meta: {title: '周综合评分', icon: 'ums-admin'}
      },
      {
        path: 'officeCapitalApply',
        name: 'officeCapitalApply',
        component: () => import('@/views/bra/officeCapitalApply/index'),
        meta: {title: '提现管理', icon: 'ums-admin'}
      },
      {
        path: 'officeContract',
        name: 'officeContract',
        component: () => import('@/views/bra/officeContract/index'),
        meta: {title: '分公司合同', icon: 'ums-admin'}
      }
    ]
  },
  
  {
    path:'/sale',
    component: Layout,
    redirect: '/sale/agent',
    name: 'sale',
    meta: {title: '销售管理', icon: 'ums'},
    children: [
       {
        path: 'agent',
        name: 'agent',
        component: () => import('@/views/sale/agent/index'),
        meta: {title: '销售管理', icon: 'ums-admin'}
      },
      {
        path: 'agentCapitalLog',
        name: 'agentCapitalLog',
        component: () => import('@/views/sale/agentCapitalLog/index'),
        meta: {title: '销售资产明细', icon: 'ums-admin'}
      },
      {
        path: 'saleAgentLog',
        name: 'saleAgentLog',
        component: () => import('@/views/sale/agentLog/index'),
        meta: {title: '销售修改记录', icon: 'ums-admin'}
      },
      {
        path: 'couponCark',
        name: 'couponCark',
        component: () => import('@/views/sale/couponCark/index'),
        meta: {title: '永久会员卡', icon: 'ums-admin'}
      },
      {
        path: 'agentCapitalApply',
        name: 'agentCapitalApply',
        component: () => import('@/views/sale/agentCapitalApply/index'),
        meta: {title: '提现管理', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/shop',
    component: Layout,
    redirect: '/shop/item',
    name: 'shop',
    meta: {title: '商城管理', icon: 'ums'},
    children: [
      {
        path: 'item',
        name: 'item',
        component: () => import('@/views/shop/item/index'),
        meta: {title: '商品管理', icon: 'ums-admin'}
      },
      {
        path: 'itemSku',
        name: 'itemSku',
        component: () => import('@/views/shop/itemSku/index'),
        meta: {title: '商品规格', icon: 'ums-admin'}
      },
      {
        path: 'itemOrder',
        name: 'itemOrder',
        component: () => import('@/views/shop/itemOrder/index'),
        meta: {title: '商品订单', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/act',
    component: Layout,
    redirect: '/act/evaluate',
    name: 'act',
    meta: {title: '活动管理', icon: 'ums'},
    children: [
      {
        path: 'mentor',
        name: 'mentor',
        component: () => import('@/views/act/mentor/index'),
        meta: {title: '导师管理', icon: 'ums-admin'}
      },
      {
        path: 'evaluate',
        name: 'evaluate',
        component: () => import('@/views/act/evaluate/index'),
        meta: {title: '评价管理', icon: 'ums-admin'}
      },
      {
        path: 'evaluateLog',
        name: 'evaluateLog',
        component: () => import('@/views/act/evaluateLog/index'),
        meta: {title: '评价记录', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/topic',
    component: Layout,
    name: 'topic',
    meta: {title: '话题管理', icon: 'ums'},
    children: [
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/topic/group/index'),
        meta: {title: '话题圈子', icon: 'ums-admin'}
      },
      {
        path: 'system',
        name: 'system',
        component: () => import('@/views/topic/system/index'),
        meta: {title: '系统弹幕', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/order',
    component: Layout,
    redirect: '/order/memberOrder',
    name: 'order',
    meta: {title: '订单管理', icon: 'ums'},
    children: [
      {
        path: 'memberOrder',
        name: 'memberOrder',
        component: () => import('@/views/fro/memberOrder/index'),
        meta: {title: '订单管理', icon: 'ums-admin'}
      },
    ]
  },
  {
    path:'/cla',
    component: Layout,
    redirect: '/cla/claCourse',
    name: 'cla',
    meta: {title: '线下课程', icon: 'ums'},
    children: [
      {
        path: 'claCourse',
        name: 'claCourse',
        component: () => import('@/views/cla/course/index'),
        meta: {title: '线下课程', icon: 'ums-admin'}
      },
      {
        path: 'courseSeries',
        name: 'courseSeries',
        component: () => import('@/views/cla/courseSeries/index'),
        meta: {title: '线下系列课程', icon: 'ums-admin'}
      },
      {
        path: 'courseEdit',
        name: 'courseEdit',
        component: () => import('@/views/cla/course/edit'),
        meta: {title: '编辑线下课程', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'claOrder',
        name: 'claOrder',
        component: () => import('@/views/cla/order/index'),
        meta: {title: '报名课程', icon: 'ums-admin'}
      },
      {
        path: 'claOrderQuery',
        name: 'claOrderQuery',
        component: () => import('@/views/cla/order/indexQuery'),
        meta: {title: '报名课程查', icon: 'ums-admin'}
      },
      {
        path: 'claOrderLog',
        name: 'claOrderLog',
        component: () => import('@/views/cla/orderLog/index'),
        meta: {title: '转让课程记录', icon: 'ums-admin'}
      },
      {
        path: 'claCourseLog',
        name: 'claCourseLog',
        component: () => import('@/views/cla/courseLog/index'),
        meta: {title: '线下课程记录', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/msg',
    component: Layout,
    name: 'msg',
    meta: {title: '消息管理', icon: 'ums'},
    children: [
      {
        path: 'template',
        name: 'template',
        component: () => import('@/views/msg/template/index'),
        meta: {title: '消息模版', icon: 'ums-admin'}
      },
      {
        path: 'pushLog',
        name: 'pushLog',
        component: () => import('@/views/msg/pushLog/index'),
        meta: {title: '推送日志', icon: 'ums-admin'}
      },
      {
        path: 'subscribe',
        name: 'subscribe',
        component: () => import('@/views/msg/subscribe/index'),
        meta: {title: '消息订阅', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/com',
    component: Layout,
    redirect: '/fro/advertise',
    name: 'com',
    meta: {title: '营销管理', icon: 'ums'},
    children: [
      {
        path: 'advertise',
        name: 'advertise',
        component: () => import('@/views/com/advertise/index'),
        meta: {title: 'Banner管理', icon: 'ums-admin'}
      },
      {
        path: 'advertiseEdit',
        name: 'advertiseEdit',
        component: () => import('@/views/com/advertise/edit'),
        meta: {title: 'Banner编辑', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'advise',
        name: 'advise',
        component: () => import('@/views/com/advise/index'),
        meta: {title: '意见反馈', icon: 'ums-admin'}
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/com/config/index'),
        meta: {title: '公共属性', icon: 'ums-admin'}
      },
      {
        path: 'shareXcx',
        name: 'shareXcx',
        component: () => import('@/views/com/config/shareXcx'),
        meta: {title: '小程序分享', icon: 'ums-admin'}
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        component: () => import('@/views/com/dictionary/index'),
        meta: {title: '字典属性', icon: 'ums-admin'}
      },
      {
        path: 'appVersion',
        name: 'appVersion',
        component: () => import('@/views/com/appVersion/index'),
        meta: {title: 'app版本', icon: 'ums-admin'}
      },
      {
        path: 'sharingMaterial',
        name: 'sharingMaterial',
        component: () => import('@/views/com/sharingMaterial/index'),
        meta: {title: '分享素材', icon: 'ums-admin'}
      },
      {
        path: 'checkin',
        name: 'checkin',
        component: () => import('@/views/com/checkin/index'),
        meta: {title: '日签签到', icon: 'ums-admin'}
      },
      {
        path: 'materialType',
        name: 'materialType',
        component: () => import('@/views/sale/materialType/index'),
        meta: {title: '必备技能分类', icon: 'ums-admin'}
      },
      {
        path: 'material',
        name: 'material',
        component: () => import('@/views/sale/material/index'),
        meta: {title: '必备技能', icon: 'ums-admin'}
      },
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/my/comment/index'),
        meta: {title: '用户评论', icon: 'ums-admin'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js